import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const WrapperBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0;
`;

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const WrapperBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
  gap: 10px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 15px;
  flex: 1;
`;

export const InputRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;

  > ${WrapperInput} {
    flex: 1 1 calc(50% - 7.5px);
    min-width: 200px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
    > ${WrapperInput} {
      min-width: 100%;
      flex: 1 1 100%;
    }
  }
`;

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
`;

export const AutocompleteItem = styled.div`
  padding: 12px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

